import {Ref, computed} from 'vue';
import {PolyDictionary} from '../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {AttribType, AttribClass} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/Constant';
import {CoreGroup} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/Group';
import {attribClassClassObject, BuildHeaders, BuildTableData} from './Common';

interface SetupForCoreGroupOptions {
	selectedAttribClass: Ref<AttribClass>;
	coreGroupAttribNames: Ref<string[]>;
	buildHeaders: BuildHeaders;
	buildTableData: BuildTableData;
}

export function SetupForCoreGroup(options: SetupForCoreGroupOptions) {
	const {selectedAttribClass, coreGroupAttribNames, buildHeaders, buildTableData} = options;

	const classObjectCoreGroupButton = computed(() => {
		return attribClassClassObject(selectedAttribClass.value == AttribClass.CORE_GROUP);
	});
	function setAttribClassCoreGroup() {
		selectedAttribClass.value = AttribClass.CORE_GROUP;
	}

	function build(coreGroup: CoreGroup) {
		coreGroupAttribNames.value = coreGroup.attribNames();
		const attrib_sizes = coreGroup.attribSizes();
		const attrib_types_by_name: PolyDictionary<AttribType> = {};
		for (let name of coreGroupAttribNames.value) {
			const type = coreGroup.attribType(name);
			if (type) {
				attrib_types_by_name[name] = type;
			}
		}
		buildHeaders(coreGroupAttribNames.value, attrib_sizes, attrib_types_by_name);
		buildTableData([coreGroup], coreGroupAttribNames.value, attrib_sizes);
	}

	return {
		classObjectCoreGroupButton,
		setAttribClassCoreGroup,
		build,
	};
}
